<script>
    export default {
        name: "HomeHero",
    };
</script>

<template>
    <section class="home-hero">
        <h1 class="home-hero__title">
            <span>Скоро</span> сайт заработает на полную. <br />Добавляем перчика
        </h1>
    </section>
</template>

<style lang="scss">
    .home-hero {
        padding: 48px 0;
        @include bp($bp-desktop-sm) {
            padding: 72px 0;
        }

        &__title {
            max-width: 285px;
            margin: 0 auto;
            color: #343434;
            font-size: 24px;
            font-weight: 600;
            line-height: 33px;
            text-align: center;

            span {
                position: relative;
                &::after {
                    content: "";
                    position: absolute;
                    z-index: -1;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    height: 12px;
                    background-color: #f8d548;
                    @include bp($bp-desktop-sm) {
                        bottom: -3px;
                        left: -5px;
                        height: 24px;
                    }
                }
            }

            @include bp($bp-desktop-sm) {
                max-width: 100%;
                font-size: 48px;
                line-height: 66px;
            }
        }
    }
</style>
